import { SkinName, isSkinName } from 'src/enums/skinName';
import { getRedirect, setRedirect } from 'src/utils/redirectUtils';

export const TOKEN_KEY = '_TOKEN';
export const SKIN_NAME = '_SKIN';

export type LogoutOptions = {
  shouldSetRedirect: boolean;
};

const { location, localStorage } = window;

const auth = () => {
  let _userId = '';
  let _pendoUserId = '';
  const cleanup = () => {
    _userId = '';
    _pendoUserId = '';
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(SKIN_NAME);
    localStorage.removeItem('bAdminMode');
    localStorage.removeItem('appId');
  };

  const logout = (options: LogoutOptions = { shouldSetRedirect: true }) => {
    if (options.shouldSetRedirect) {
      setRedirect(location.href);
    }
    const domain =
      location.origin.includes("Expretio XCS")
        ? process.env.REACT_APP_CC_APP_XCS_DOMAIN
        : process.env.REACT_APP_CC_APP_DOMAIN;

    location.replace(`${domain}/d/home/logout/`);
    cleanup();
  };

  return {
    getRedirect,
    setRedirect,

    getSkin: (): SkinName | null => {
      const skinName = localStorage.getItem(SKIN_NAME);
      return skinName && isSkinName(skinName) ? skinName : null;
    },

    setSkin: (skin: string) => {
      localStorage.setItem(SKIN_NAME, skin);
    },

    getToken: () => {
      return localStorage.getItem(TOKEN_KEY);
    },

    setToken: (token: string) => {
      localStorage.setItem(TOKEN_KEY, token);
    },

    getUserId: () => {
      return _userId;
    },

    setUserId: (userId: string) => {
      _userId = userId;
    },

    getRootUser: () => {
      return _pendoUserId
    },

    setRootUser: (rootUserId: string) => {
      _pendoUserId = rootUserId;
    },

    cleanup,
    logout,
  };
};

export default auth();